"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _TemperatureStatusModule = _interopRequireDefault(require("../../styles/components/Circles/TemperatureStatus.module.css"));
var _hooks = require("../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ValueStatusText = _ref => {
  var _useSelector;
  let {
    thingPDIDDevice,
    regular,
    tKey = null
  } = _ref;
  const {
    value = null,
    unit = null
  } = (0, _hooks.useGetValueByRegDeviceId)({
    thingPDIDDevice,
    regular: new RegExp(regular)
  });
  const {
    31: noData,
    [tKey]: tPrefix = ''
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const tVUnit = ((_useSelector = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues)) === null || _useSelector === void 0 || (_useSelector = _useSelector.Default) === null || _useSelector === void 0 ? void 0 : _useSelector.unit) || {};
  const text = (0, _react.useMemo)(() => {
    const val = value !== null ? +value >= 100 ? (+value).toFixed(0) : (+value).toFixed(1) : '--';
    return "".concat(tPrefix, " ").concat(val, " ").concat(tVUnit[unit] || '');
  }, [tPrefix, value, unit]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: _TemperatureStatusModule.default.sub_box
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TemperatureStatusModule.default.subtitle
  }, /*#__PURE__*/_react.default.createElement("span", null, text !== null && text !== void 0 ? text : noData))), [noData, text]);
};
var _default = exports.default = ValueStatusText;